import { render, staticRenderFns } from "./ROIChartMISPotential.vue?vue&type=template&id=618e40fb&scoped=true&"
import script from "./ROIChartMISPotential.vue?vue&type=script&lang=js&"
export * from "./ROIChartMISPotential.vue?vue&type=script&lang=js&"
import style0 from "./ROIChartMISPotential.vue?vue&type=style&index=0&id=618e40fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e40fb",
  null
  
)

export default component.exports